module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_7005.0ae70ffd.png";